<template>
	<div class="sa-chat">
		<div class="sa-chat-messages" ref="messageContainer">
			<div v-for="(message, index) in messages" :key="index" :class="['sa-chat-messages-message', message.isUser ? 'sa-chat-messages-user-message' : 'sa-chat-messages-bot-message']">
				<span class="sa-chat-messages-sender">{{ message.isUser ? "Tu" : "Otsis" }}:</span>
				<!-- {{ message.text }} -->
				<!-- <div v-html="message.text" class="message-content"></div> -->

				<vue-markdown :source="message.text"></vue-markdown>
			</div>
		</div>

		<div class="sa-chat-input-area">
			<input v-model="newMessage" @keyup.enter="sendMessage" placeholder="Scrivi un messaggio..." />
			<button @click="sendMessage" :disabled="!newMessage.trim()">Invia</button>
		</div>
	</div>
</template>

<script>
import VueMarkdown from "vue-markdown";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
	mixins: [UtilityMixin],
	components: { VueMarkdown },
	data() {
		return {
			// Array che conterrà tutti i messaggi
			messages: [],
			// messages: [
			// 	{ text: "Benvenuto nella chat!", isUser: false },
			// 	{ text: "Digita il tuo primo messaggio.", isUser: false },
			// ],
			// Variabile che memorizza il testo dell'input corrente
			newMessage: "",
			streamData: "",
			authToken: null,
			charIndex: 0,
			responseDate: null,
			typingSpeed: 120,
		};
	},
	mounted() {
		this.authToken = this.$route.query.authToken;
		this.messages.push({ text: "Benvenuto " + this.user.nominativoUtente.trim() + "!", isUser: false });
		// Chiama lo scroll iniziale quando il componente è montato
		this.scrollToBottom();
	},
	methods: {
		sendMessage() {
			// 1. Controlla che il messaggio non sia vuoto (dovrebbe essere già bloccato dal disabled)
			if (!this.newMessage.trim()) return;

			// 2. Aggiunge il messaggio dell'utente all'array
			this.messages.push({
				text: this.newMessage.trim(),
				isUser: true, // Indica che è un messaggio inviato dall'utente
			});

			// 4. Scorre verso il basso dopo aver aggiunto il messaggio
			// Lo eseguiamo in 'nextTick' per assicurarci che il DOM sia aggiornato
			this.$nextTick(() => {
				this.scrollToBottom();
			});

			// 5. Simula una risposta automatica (opzionale)
			//this.simulateBotResponse();

			this.streamPostRequest();
		},

		/**
		 * Scorre il contenitore dei messaggi fino alla fine.
		 */
		scrollToBottom() {
			const container = this.$refs.messageContainer;
			// Imposta lo scroll verticale al massimo della sua altezza
			container.scrollTop = container.scrollHeight;
		},

		/**
		 * Funzione di simulazione risposta bot.
		 */
		simulateBotResponse() {
			setTimeout(() => {
				const botResponse = "Ho ricevuto il tuo messaggio. Grazie!";
				this.messages.push({
					text: botResponse,
					isUser: false,
				});
				// Scorre di nuovo dopo che il bot ha risposto
				this.$nextTick(() => {
					this.scrollToBottom();
				});
				this.prova();
			}, 800); // Ritardo di 800ms per la simulazione
		},
		prova() {
			setTimeout(() => {
				if (this.messages.length === 4) {
					this.messages[3].text += " ok";
					this.prova();
					// Scorre di nuovo dopo che il bot ha risposto
					this.$nextTick(() => {
						this.scrollToBottom();
					});
				}
			}, 3000); // Ritardo di 800ms per la simulazione
		},
		async streamPostRequest() {
			this.messages.push({
				text: "In attesa della risposta del server",
				isUser: false,
			});
			this.streamData = "";
			const url = "/api/teststream";
			// ... postData e headers ...
			let postData = { message: this.newMessage };
			// 3. Pulisce il campo di input
			this.newMessage = "";
			try {
				const response = await fetch(url, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + this.authToken,
					},
					body: JSON.stringify(postData),
				});

				if (!response.ok) {
					throw new Error(`Errore HTTP! stato: ${response.status}`);
				}

				this.streamData = "";
				const reader = response.body.getReader();
				const decoder = new TextDecoder("utf-8");
				let buffer = ""; // <--- Buffer per accumulare i dati incompleti
				let x = true;
				while (x) {
					const { done, value } = await reader.read();

					if (done) {
						console.log("Stream completato.");
						// Elabora qui qualsiasi dato rimasto nel buffer se necessario
						break;
					}
					// console.log(buffer);
					buffer += decoder.decode(value, { stream: true });
					// console.log("---------------------------------");
					// console.log(buffer);
					// console.log("---------------------------------");
					let lastEventEnd = 0;
					this.processaRisposta(buffer);
					buffer = buffer.substring(lastEventEnd);
				}
			} catch (error) {
				console.error("Si è verificato un errore durante lo streaming:", error);
			}
		},
		processaRisposta(buffer) {
			this.charIndex = 0;
			this.messages[this.messages.length - 1].text = "";
			if (buffer != undefined) {
				this.responseDate = buffer.split("\n\n");
				this.writeData();
				//console.log(x.length);
			}
		},
		writeData() {
			if (this.charIndex < this.responseDate.length) {
				let linea = this.responseDate[this.charIndex];
				let testo = linea.substring("data: ".length).trim();
				if (testo) {
					//console.log(testo);
					let dataObject = JSON.parse(testo);
					this.messages[this.messages.length - 1].text += dataObject.message.content;
					//this.streamData += dataObject.message.content;
					this.charIndex++;
					setTimeout(this.writeData, this.typingSpeed);
				}
			}
		},
	},
};
</script>

<style scoped></style>
